import React from "react"

function TopNav(props) {
	return (
		<>
			<div className="top-nav">
				<h5>Select the correct path for the resources <span>👇</span></h5>
				<a target="_blank"  rel="noreferrer" href="https://teachers.campk12.com/support" className="btn">Instructor Query</a>
				
			</div>
		</>
	)
}

export default TopNav
